import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Returns the in-code form definition for the interaction type creation and edit form.
 *
 * Previously stored as seed data in the `form_definitions` table (id: `interaction_type_form`).
 * Moved to code so the definition can be updated without schema changes or migrations.
 *
 * A `translate` function is accepted so labels and descriptions are resolved at
 * runtime (e.g. via TranslationService) rather than being baked in as static strings.
 */
export function getFormFormFields(translate: (key: string) => string): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      wrappers: ['inline-edit'],
      props: {
        label: translate('form.formDefinition.nameLabel'),
        placeholder: translate('form.formDefinition.namePlaceholder'),
        required: true,
        inlineEditVariant: 'title',
      },
    },
    {
      key: 'prefill_last_values',
      type: 'checkbox',
      props: {
        label: translate('form.formDefinition.prefillLabel'),
        description: translate('form.formDefinition.prefillDescription'),
      },
    },
    {
      key: 'auto_submit',
      type: 'checkbox',
      props: {
        label: translate('form.formDefinition.autoSubmitLabel'),
        description: translate('form.formDefinition.autoSubmitDescription'),
      },
    },
    {
      key: 'play_success_sound',
      type: 'checkbox',
      props: {
        label: translate('form.formDefinition.playSoundLabel'),
        description: translate('form.formDefinition.playSoundDescription'),
      },
    },
  ];
}
